<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ack"> </p>
<p class="BMH"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="BMTNI">This book could never have been written without the following authors: William Faulkner (especially for his novel <span class="ePub-I">Absalom, Absalom!)</span>, Zora Neale Hurston, James Weldon Johnson, W. E. B. DuBois, Charles W. Chestnutt, Laura C. Jarmon, Marc Fisher, Lorraine Johnson-Coleman, Dennis Danvers (for giving me <span class="ePub-I">A Richmond Reader</span> on indefinite loan), Carol A. Kolmerten, Stephen M. Ross, Judith Bryant Wittenberg, Adam Braver, Edward P. Jones, Langston Hughes, Gloria Naylor, and last but not least, Toni Morrison and Alice McDermott.</p>
<p class="BMTX">People I can’t thank enough for their help and support and numerous rereadings of the manuscript: Lisa Grubka, my fabulous agent, and Barbara Jones, my amazing editor and teacher.</p>
<p class="BMTX">Any acknowledgment would be incomplete without thanking Vicki Sipe for her love and patience when I needed a quiet house, and her willingness to read, read, read, and read again.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?e7324a6a